import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {BaseButton, BaseModal, BaseSpinner} from "@/components";
import useGetUserWithdrawalLimit from "../../../../hooks/wallet/useGetUserWithdrawalLimit";
import {formatBalanceWithCurrency} from "../../../../util/balance.util";

const WithdrawalLimits = () => {
  const {data, isLoading} = useGetUserWithdrawalLimit();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {t} = useTranslation();

  const dailyPercent = Math.floor(data?.DailyPercentage);
  const weeklyPercent = Math.floor(data?.WeeklyPercentage);

  const dailyWithdrawal = formatBalanceWithCurrency(data?.WithdrawnToday);
  const weeklyWithdrawal = formatBalanceWithCurrency(data?.WithdrawnThisWeek);

  const dailyRemaining = formatBalanceWithCurrency(data?.RemainingDaily);
  const weeklyRemaining = formatBalanceWithCurrency(data?.RemainingWeekly);

  const isMobile = window.innerWidth <= 768;

  const FontSize = "16px";

  useEffect(() => {
    if (dailyPercent === 100 || weeklyPercent === 100) {
      setTimeout(() => {
        setIsModalOpen(true);
      }, 2000);
    }
  }, [dailyPercent, weeklyPercent]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <BaseModal
        title={t("withdrawalStepsModalLimitReachedTitle")}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="md"
      >
        {dailyPercent === 100 && (
          <h4 style={{fontSize: isMobile ? FontSize : undefined}}>{t("withdrawalDayModalLimitReachedMessage")}</h4>
        )}
        {weeklyPercent === 100 && (
          <h4 style={{fontSize: isMobile ? FontSize : undefined}}>{t("withdrawalWeekModalLimitReachedMessage")}</h4>
        )}
        <BaseButton
          variant="primary"
          onClick={handleOk}
          style={{display: "block", width: "100%", marginTop: "1rem"}}
        >
          {t("withdrawalStepsModalLimitReachedButton")}
        </BaseButton>
      </BaseModal>
      {isLoading && <BaseSpinner size="lg" />}
      {!isLoading && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "flex-start" : "space-between",
            textAlign: "left",
            borderRadius: "var(--radius-md)",
            padding: "0 20px 0 0",
            gap: isMobile ? 24 : 0,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              ...(isMobile && {
                width: "315px",
                height: "187px",
                borderRadius: "var(--radius-xl)",
                gap: "13px",
                opacity: 1,
                padding: "var(--space-3-5)",
                background: "#292936",
                boxShadow: "0px 2px 6px 2px #00000026, 0px 1px 2px 0px #0000004D",
                alignItems: "center",
                justifyContent: "center",
              }),
            }}
          >
            {isMobile ? (
              <>
                {/* Percentage on top with special styling for mobile */}
                <h4
                  style={{
                    margin: "0",
                    fontSize: "var(--font-display)",
                    fontFamily: "Poppins",
                    fontWeight: 700,
                    lineHeight: "var(--leading-5xl)",
                    textAlign: "center",
                    color: "var(--color-primary)",
                  }}
                >
                  {dailyPercent}%
                </h4>

                {/* Title centered for mobile */}
                <h4
                  style={{
                    margin: "0",
                    fontSize: FontSize,
                    textAlign: "center",
                    color: "var(--color-secondary)",
                  }}
                >
                  {t("withdrawalStepsDailyWithdrawal")}
                </h4>

                {/* Withdrawn and remaining data for mobile */}
                <div style={{width: "100%"}}>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "left",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {t("withdrawalStepsWithdrawn")}:
                    </h4>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "left",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {" "}
                      {dailyWithdrawal}
                    </h4>
                  </div>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "left",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {t("withdrawalStepsDailyRemaining")}:
                    </h4>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "left",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {dailyRemaining}
                    </h4>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsDailyWithdrawal")}: {dailyPercent}%
                </h4>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsWithdrawn")}: {dailyWithdrawal}
                </h4>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsDailyRemaining")}: {dailyRemaining}
                </h4>
              </>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              ...(isMobile && {
                width: "315px",
                height: "187px",
                borderRadius: "var(--radius-xl)",
                gap: "13px",
                opacity: 1,
                padding: "var(--space-3-5)",
                background: "#292936",
                boxShadow: "0px 2px 6px 2px #00000026, 0px 1px 2px 0px #0000004D",
                alignItems: "center",
                justifyContent: "center",
              }),
            }}
          >
            {isMobile ? (
              <>
                {/* Percentage on top with special styling for mobile */}
                <h4
                  style={{
                    margin: "0",
                    fontSize: "var(--font-display)",
                    fontFamily: "Poppins",
                    fontWeight: 700,
                    lineHeight: "var(--leading-5xl)",
                    textAlign: "center",
                    color: "var(--color-primary)",
                  }}
                >
                  {weeklyPercent}%
                </h4>

                {/* Title centered for mobile */}
                <h4
                  style={{
                    margin: "0",
                    fontSize: FontSize,
                    textAlign: "center",
                    color: "var(--color-secondary)",
                  }}
                >
                  {t("withdrawalStepsWeeklyWithdrawal")}
                </h4>

                {/* Withdrawn and remaining data for mobile */}
                <div style={{width: "100%"}}>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "center",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {t("withdrawalStepsWithdrawn")}:
                    </h4>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "center",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {weeklyWithdrawal}
                    </h4>
                  </div>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "center",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {t("withdrawalStepsWeeklyRemaining")}:
                    </h4>
                    <h4
                      style={{
                        margin: "4px 0",
                        fontSize: FontSize,
                        textAlign: "center",
                        color: "var(--color-secondary)",
                      }}
                    >
                      {weeklyRemaining}
                    </h4>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsWeeklyWithdrawal")}: {weeklyPercent}%
                </h4>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsWithdrawn")}: {weeklyWithdrawal}
                </h4>
                <h4
                  style={{
                    margin: "8px 0",
                    fontSize: FontSize,
                  }}
                >
                  {t("withdrawalStepsWeeklyRemaining")}: {weeklyRemaining}
                </h4>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawalLimits;
